export default class {
  constructor() {
    this.state = {
      showModal: false,
      showDeleteModal: false
    }
    this.getters = {}
    this.mutations = {
      ON_CHANGE_MODAL(state, res) {
        state.showDeleteModal = false
        state.showModal = res.visible
      },
      SHOW_DELETE_MODAL: (state, res) => {
        state.showDeleteModal = res.visible
      }
    }
    this.actions = {
      onChangeModal({ commit }, params) {
        commit('ON_CHANGE_MODAL', params)
        commit('app/TOGGLE_VERTICAL_SCROLLBAR', params.visible, {
          root: true
        })
      },
      setShowDeleteModal: ({ commit }, params) => {
        commit('SHOW_DELETE_MODAL', params)
      }
    }
  }
}
